@let isLoading = isLoading$ | async;
<div class="dialog-header">
  <span class="title">Transfer Wallet</span>
  <span class="sub-title">Move funds between your wallets</span>
</div>
<form mat-dialog-content class="dialog-content" [formGroup]="form" (submit)="handleSubmit()">
  <div [class.hidden]="showConfirmation() || transferNotice()" class="tabs">
    @for (tab of tabs; track tab.value) {
      @let isActive = transferTypeCtrl?.value === tab.value;
      <button
        [disabled]="isLoading"
        type="button"
        (click)="setTransferType(tab.value)"
        [class.bg-primary]="isActive"
        [class.text-secondary]="isActive"
        class="tab">
        {{ tab.label }}
      </button>
    }
  </div>

  <div [class.hidden]="showConfirmation()" class="balance-display">
    <div class="from">
      <span class="label">From</span>
      <b class="value">{{ fromBalance | number: "1.2-2" }}</b>
    </div>
    <div class="to">
      <span class="label">To ({{ toDescription }})</span>
      <span class="value">{{ toBalance | number: "1.2-2" }}</span>
    </div>
  </div>

  <div [class.hidden]="showConfirmation() || transferNotice()" class="default-amounts">
    @for (amount of defaultAmounts; track amount; let i = $index) {
      @let isSelected = amount === selectedAmount;
      <button
        [disabled]="amount > fromBalance || isLoading"
        type="button"
        (click)="setAmount(amount)"
        [class.bg-primary]="isSelected"
        [class.text-secondary]="isSelected"
        [class.font-bold]="isSelected"
        class="btn-amount">
        {{ amount }}
      </button>
    }
  </div>

  <div [class.hidden]="showConfirmation() || transferNotice()" class="custom-amount">
    <label for="amount">or enter custom amount</label>
    <div class="custom-amount-input">
      <input
        [attr.tabindex]="isLoading ? -1 : 0"
        [attr.aria-disabled]="isLoading"
        [attr.inert]="isLoading ? '' : null"
        [class.disabled-input]="isLoading"
        formControlName="AMOUNT"
        id="amount"
        type="text"
        numbersOnly
        [min]="1"
        [max]="fromBalance" />
      @let upperLimitReached = selectedAmount >= fromBalance;
      @let lowerLimitReached = selectedAmount <= 1;
      <button type="button" [disabled]="upperLimitReached || isLoading" (click)="adjustAmount('increase')" class="btn-handle btn-up">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button type="button" [disabled]="lowerLimitReached || isLoading" (click)="adjustAmount('decrease')" class="btn-handle btn-down">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <button type="button" [disabled]="isLoading" (click)="setMax()" class="btn-max bg-primary">Max.</button>
    </div>
    <div class="error-messages">
      @if (amountCtrl?.hasError("required") && amountCtrl?.touched && amountCtrl?.dirty) {
        <span class="error-message"><mat-icon fontSet="material-icons-outlined">info</mat-icon> Please select or enter amount</span>
      }

      @if (isBalanceInsufficient) {
        <span class="error-message"><mat-icon fontSet="material-icons-outlined">info</mat-icon> Insufficient Funds</span>
      }
    </div>
    <mat-progress-bar [class.hidden]="!isLoading" color="accent" mode="indeterminate"></mat-progress-bar>
  </div>

  <button
    [class.hidden]="showConfirmation() || transferNotice()"
    [disabled]="isTransferInvalid || isLoading"
    type="button"
    class="btn-transfer bg-primary text-secondary"
    (click)="confirmTransfer()">
    {{ isLoading ? "Transferring..." : "Transfer" }}
  </button>

  <div [class.hidden]="!showConfirmation()" class="confirmation">
    <span class="title">Confirm Transfer</span>
    <b class="balance text-primary">{{ selectedAmount | number: "1.2-2" }}</b>
    <span class="description text-primary">From: {{ fromDescription }} <mat-icon>east</mat-icon> To: {{ toDescription }}</span>
    <div class="actions">
      <button class="btn-back" type="button" (click)="showConfirmation.set(false)">Back</button>
      <button class="btn-confirm bg-primary text-secondary font-bold" type="submit">Confirm</button>
    </div>
  </div>

  <div
    class="notice"
    [ngClass]="{
      'success-notice': transferNotice() === 'success',
      'error-notice': transferNotice() === 'error',
      hidden: !transferNotice(),
    }">
    <div class="notice-header"><mat-icon (click)="closeNotice()">close</mat-icon></div>
    <mat-icon class="icon">{{ transferNotice() === "success" ? "check" : "close" }}</mat-icon>
    <b class="title">
      {{ selectedAmount | number: "1.2-2" }}
      {{ transferNotice() === "success" ? "transferred" : "transfer not successful" }}
    </b>
    <span class="description">{{ fromDescription }} <mat-icon>east</mat-icon> {{ toDescription }}</span>
  </div>
</form>
